module.exports = __webpack_public_path__ + "img/oneday1-1.dd907693.jpg";